import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FilePond } from "react-filepond";
import { config as serverUploadConfig } from "../../helpers/serverUpload";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {Button} from "react-bootstrap";
import DialogComponent from "../../components/Project/Dialog";
import { platform } from "./../../Style/index";
import actionGlobalConsultation from "../../actions/gobalConsultation";
import { inputsComentsForm } from "../../constants/constantsGlobalConsultation";
import CustomTextFild from "../custom/CustomTextFied";
import validationUtils from "../../js/validators";
import CustomButton from "../custom/CustomButton";
import CustomAlert from "../custom/CustomAlert";
import CustomLoader from "../custom/CustomLoader";
import { dataEncoding } from "../../helpers/serverEncoding";
import {Card, Col, Container, Form, Row } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import HabeasData from "../Security/HabeasData";
import Error from "../Form/Error";

import fileUpload from "./../../images/file-upload.png";

function CommentsForm({ idProject, stateComments }) {
  const [formValues, setFormValues] = useState({
    name: "",
    email: ""
  });
  const [form, setForm] = useState({
    isAuthorized: false
  }
  )
  const [isAlert, setIsAlert] = useState(false)
  const [view, setView] = useState(false)
  const [alert, setAlert] = useState("danger")
  const [fieldAlert, setFieldAlert] = useState({})
  const [errors, setErrors] = useState({
    name: false,
    email: false,
  });
  const [recaptchaValue, setRecaptchaValue] = useState("")
  const [allNews, setAllNews] = useState([]);
  const [document, setDcument] = useState([]);
  const [openLoader, setOpenLoader] = useState(false);
  const [showHabeasData, setShowHabeasData] = useState(false)
  const [habeasData, setHabeasData] = useState("")
  const { t, i18n } = useTranslation();

  const actualizarEtiquetas = (etiquetas) => {
    return etiquetas.map((etiqueta) => {
      const nuevaEtiqueta = t(
        `globalConsultation.initiatives.labelsInputs.${etiqueta.name.toLowerCase()}`
      );
      return { ...etiqueta, label: nuevaEtiqueta };
    });
  };

  const nuevasEtiquetas = actualizarEtiquetas(inputsComentsForm);

  const resetValues = () => {
    setIsAlert(false)
    setForm({ isAuthorized: false})
    window.grecaptcha.reset();
    setRecaptchaValue("")
    setFormValues({
      name: "",
      email: "",
    });
    setErrors({
      name: false,
      email: false,
    });
    setDcument([]);
  };

  const handleChange = (e) => {

    if (
      ["name", "company"].includes(e.target.name) &&
      !/^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚüÜ. /]*$/.test(e.target.value )
    ) {
      return; 
    }

  setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const sendComment = async () => {
    let fileInformation = {};

    if (document && document.length > 0) {
      if (
        Object.keys(document[0].getMetadata()).length > 0 &&
        document[0].getMetadata().name
      ) {
        fileInformation = document[0].getMetadata();
      } else {
        fileInformation = JSON.parse(document[0].serverId);
      }
    }

    const data = {
      project_id: idProject,
      name: formValues.name,
      document_number: formValues.document_number,
      email: formValues.email,
      company: formValues.company,
      message: dataEncoding(formValues.message),
      is_document: Object.keys(fileInformation).length > 0 ? 1 : 0,
      document_name:
        Object.keys(fileInformation).length > 0 ? fileInformation.name : "",
      document: Object.keys(fileInformation).length > 0 ? fileInformation : "",
    };

    const response =
      await actionGlobalConsultation.postGlobalConsultationCommetn(data);

    if(response.status) {
      setView(response.status === 200 ? true : false)
      setAlert(response.status === 200 ? "sucess" : "danger")
    }

    
    return response;
  };


  const formValid = () => {

    let codeMessages = []
    let errorsObject = {}

    let pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    
    if(formValues.name === ""){
      errorsObject = {...errorsObject, name: true}
      codeMessages.push({
        message: t(`globalConsultation.validations.name`)
      })
    }
    if(formValues.email === "" || !pattern.test(formValues.email)){
      errorsObject = {...errorsObject, email: true}
      codeMessages.push({
        message: t(`globalConsultation.validations.email`)
      })
    }
    if(document.length <= 0){
      codeMessages.push({
        message: t(`globalConsultation.validations.documents`)
      })
    }
    if(form.isAuthorized=== false){
      codeMessages.push({
        message: t(`globalConsultation.validations.personalData`)
      })
    }
    if(recaptchaValue === ""){
      codeMessages.push({
        message: t(`globalConsultation.validations.reCaptcha`)
      })
    }

    if (codeMessages.length > 0) {
      setErrors(errorsObject)
      setIsAlert(true)
      setFieldAlert({
          type: "danger",
          message: codeMessages,
      })
      return false
    } else {
      return true
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {


      if (formValid()) {
        setOpenLoader(true);
        const request = await sendComment();

        if (request.status === 200) {
          stateComments(request.response);
          setOpenLoader(false);
          resetValues();
        } else if (request.status === 500) {
          setOpenLoader(false);
        }
      }
    } catch (error) {
      console.error("Error al manejar el formulario:", error);
      // Puedes manejar el error de alguna manera, por ejemplo, mostrar un mensaje al usuario.
    }
  };

  const onChange =
    (name, check = false) =>
    (event) => {

      setFormValues({ ...formValues, [name]: event.target.checked})
      setForm({
        [name]: event.target.checked,
      })
  }


  const handleShowHabeasData = () => {
    setShowHabeasData(true)
  }

  const handleFilePondError = (error) => {
    setAllNews([
      {
        name: "archivo",
        message:t("globalConsultation.messages.fileRegistered")
          ,
      },
    ]);
  };


  const onChangeReCAPTCHA = (value) => {
    setRecaptchaValue(value);
  };

  return (
    <>
      <DialogComponent
        t={t}
        view={view}
        alert={true}
        alertMessage={t("globalConsultation.messages.commentSucess")}
        alertType={"success"}
        buttons={[
          {
            value: `${t("buttons.accept")}`,
            onclick: () => {
              setView(false)
            },
          },
        ]}
      />
      <form onSubmit={handleSubmit}>
        <Paper
          elevation={4}
          style={{ width: "100%", padding: 40, marginBottom: 40 }}
        >
          <Grid
            container
            spacing={3}
            direction="row"
            justifyContent="start"
            alignItems="center"
            alignContent="center"
            wrap="wrap"
          >
            <Grid item md={12} xs={12} sm={12}>
              <p>{t("globalConsultation.messages.contactInfo")}</p>
            </Grid>
            {nuevasEtiquetas.map((input) => (
              <Grid item md={input.column} key={input.id}>
                <CustomTextFild
                  label={`${input.label}`+ ( input.required ? "*" : "")}
                  name={input.name}
                  type={input.type}
                  value={formValues[input.name]}
                  change={handleChange}
                  fullWidth={input.fullWidth}
                  multiline={input.multiline}
                  rows={input.rows}
                  error={input.required ? errors[input.name] : false}
                />
              </Grid>
            ))}

            <Grid item md={12}>
              <Typography
                variant="body1"
                color="initial"
                style={{ color: "rgba(0, 0, 0, 0.6)", marginBottom: 10 }}
              >
                {t("filePond.project.documentSelect")}
              </Typography>
              <FilePond
               style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
                labelIdle={`<div style="display:flex, align-items:center">
                                          <img src="${fileUpload}" style="width: 3rem; height: 3rem; cursor: pointer;"/>
                                        </div>`}
                acceptedFileTypes={[
                      "application/msword", 
                      "application/pdf",
                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", 
                    ]}
                files={document}
                allowMultiple={false}
                maxFiles={1}
                server={serverUploadConfig(
                  "/api/file/upload",
                  "generalconsultation"
                )}
                allowImagePreview={false}
                onupdatefiles={(fileItems) => setDcument(fileItems)}
                onerror={(error) => handleFilePondError(error)}
              />
            </Grid>

            <Grid itme md={12}>
            <Form.Group as={Col} style={{ textAlign: "center" }}>
              <Form.Label onClick={() => {}}>
                <Form.Check
                  type="checkbox"
                  inline
                  defaultChecked={false}
                  checked={form.isAuthorized}
                  onChange={onChange("isAuthorized", true)}
                />
                {t("formRegister.personalData.part1")}
                <span
                  onClick={() => {handleShowHabeasData()}}
                  style={{ color: "#00966C", cursor: "pointer" }}
                >
                  {t("formRegister.personalData.part2")}
                </span>
              </Form.Label>
            </Form.Group>
            </Grid>
            <Grid item md={12} sx={{paddingTop: 0}}>
              <Form.Group
                as={Col}
                controlId="formGridReCaptcha"
                style={{ textAlign: "center" }}
              >
                <Form.Label
                  style={{
                    height: "35px",
                    marginTop: "2rem",
                    marginBottom: "2rem",
                    textAlign: "center",
                  }}
                >
                  <ReCAPTCHA
                    sitekey="6LefRPYdAAAAANdQTSZ4NA-OV2BmT3dojawQ8-Gf"
                    onChange={onChangeReCAPTCHA}
                    hl={i18n.language}
                  />
                </Form.Label>
              </Form.Group>
            </Grid>

              {isAlert && (
                  <Error options={fieldAlert.message} value={fieldAlert.type}></Error>
                )}

            <Grid
              item
              md={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",

              }}
            >
              <Button
              type={"submit"}
                        style={{
                          ...platform.buttonSuccess,
                          marginTop: "0.5rem",
                        }}>{t("buttons.send")}</Button>
              {/* <CustomButton
                type={"submit"}
                style={"green"}
                text={t("buttons.send")}
              /> */}
            </Grid>
          </Grid>
          <CustomLoader open={openLoader} setOpen={setOpenLoader} />
          <HabeasData
            showTerms={showHabeasData}
            text={habeasData}
            handleClose={() => { setShowHabeasData(false)}}
          />
        </Paper>
      </form>
    </>
  );
}

export default CommentsForm;
